export default __webpack_public_path__ + "static/media/COVER.427d2f36.JPG";